import React from "react"
import { PostProvider } from '~/contexts/PostContext'

import BlogHero from '~/components/blog/blog-hero'
import BlogCopy from '~/components/blog/blog-copy'
import BlogCopyImg from '~/components/blog/blog-copy-img'
import ThreeImgGrid from '~/components/blog/three-img-grid'
import ImgCols from '~/components/blog/img-cols'
import SwipeImgCols from '~/components/blog/swipe-img-cols'
import BlogVideo from '~/components/blog/blog-video'
import BlogStore from '~/components/blog/blog-store'
import BlogColl from '~/components/blog/blog-coll'
import Multicol from '~/components/blog/multicol'
import BlogCarou from '~/components/blog/blog-carou'
import FakeTiles from '~/components/blog/blog-faketiles'
import FeatureBox from '~/components/blog/feature-box'
import CarouselProducts from '~/components/carousel/carousel_products'
import Journal from '~/components/home/journal'
import { StoryStamp, StoryQuote } from '~/components/blog/randoms'

import { stores_title } from "~/styles/blog/blog.module.scss"

const Blocks = ({ post, videos, pgprops={} }) => {
  const { blocks } = post.data

  const first_title = !!blocks ? blocks.find(x => x.settings.hasOwnProperty('title') && x.settings.title && x.settings.title !== '') : false
  const title_index = first_title ? blocks.findIndex( x => x === first_title) : 0


  return (
    <PostProvider post={post} pgprops={pgprops}>
      {blocks && blocks.map( (block, index) => 
        <React.Fragment key={`blogblock${index}`}>
          {(block.type === 'story_full') && (
            <BlogHero 
              blockId={block.id}
              index={index} 
              pdp={post.id === 'collblocks'}
            />
          )}
          {(block.type === 'story_copy' && !block.settings.sec_image) && (
            <BlogCopy 
              blockId={block.id}
              index={index} 
              add_h1={index === title_index} 
              collblocks={post.id === 'collblocks'}
            />
          )}
          {(block.type === 'story_copy' && block.settings.sec_image) && (
            <BlogCopyImg 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'story_stamp') && (
            <StoryStamp 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'story_quote') && (
            <StoryQuote 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'story_coll_full') && (
            <>
              {(block.settings.carousel) ? (
                <CarouselProducts block={block} index={index} />
              ) : (
                <BlogColl blockId={block.id} index={index} />
              )}
            </>
          )}
          {(block.type === 'story_three_image') && (
            <ThreeImgGrid 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'story_twoimg') && (
            <>
              {(block.settings?.swipe) ? (
                <SwipeImgCols 
                  blockId={block.id}
                  index={index} 
                />
              ) : (
                <ImgCols 
                  blockId={block.id}
                  index={index} 
                />
              )}
            </>
          )}
          {(block.type === 'story_video') && (
            <BlogVideo 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'story_store' && index === blocks.findIndex( x => x.type === 'story_store')) && (
            <h2 className={stores_title} id='stores'>
              Store Locations
            </h2>
          )}
          {(block.type === 'story_store') && (
            <BlogStore 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'carousel') && (
            <BlogCarou 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'multicol') && (
            <Multicol 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'story_tiles') && (
            <FakeTiles 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'story_features') && (
            <FeatureBox 
              blockId={block.id}
              index={index} 
            />
          )}
          {(block.type === 'journal') && (
            <Journal 
              block={block}
              index={index} 
              blog={true}
            />
          )}
        </React.Fragment>
      )}
    </PostProvider>
  )
}

export default Blocks
